import React, { useEffect, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { employee_list_details } from "../../../core/data/json/employees_list_details";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import EmpSuccess from "../employees/employeeSuccess";
import "../employees/index.css";
import { uploadFile } from "../../../apis/auth";
import { createNewVisitor } from "../../../apis/visitors";
import { getAllNationalsSuper_Distributor } from "../../../apis/nationals";
import Select from "react-select";
import { getAllEmployee } from "../../../apis/employees";
import { formatDate } from "../../../environment";
import * as XLSX from "xlsx";

type EmployeeResponse = {
  full_name: string;
  id: any;
};

type EmployeeData = {
  value: any;
  label: any;
};
type sDResponse = {
  full_name: string;
  adress: string;
  geo_location: string;
  Image: string;
  email: string;
  phone_number: string;
  profile_pic: string;
  createdAt: string;
  Status: string;
  address: string;
  id: any;
};

type sdistributorData = {
  key: string;
  Name: string;
  Image: string;
  Email: string;
  geo_location: string;
  Phone: string;
  address: string;
  Status: string;
  id: any;
  createdAt: string;
};

const VisitorsList = () => {
  const initialValues = {
    name: "",
    discription: "",
    address: "",
    email: "",
  };
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [error, setError] = useState<string>("");
  const [formData, setFormData] = useState(initialValues);
  const { name, discription, email, address } = formData;
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [oneTimeaVisit, setOneTimeVisit] = useState(false);
  const [regularVisit, setRegularVisit] = useState(false);
  const [sDistributorData, setSdistributorData] = useState<sdistributorData[]>(
    []
  );
  const [products, setProducts] = useState<any>();

  const getAllEmployees = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllEmployee(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          label: item.full_name ? item.full_name : "Not Assigned",
          value: item.id || "Not Assigned",
        })
      );
      setEmployeeData(employeeData);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const fetchAllSuperDistributor = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllNationalsSuper_Distributor(data);
      const employeeData = response?.data?.superDistributorData?.map(
        (item: sDResponse, i: number) => ({
          key: `${i + 1}`,
          createdAt: formatDate(item.createdAt),
          Name: `${item.full_name}`,
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${
                parsed.states || ""
              }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Image: item.profile_pic ? item.profile_pic : "dummy",
          Email: item.email || "--",
          Phone: item.phone_number || "--",
          Status: item.Status || "--",
          id: item.id || "--",
        })
      );
      setSdistributorData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    getAllEmployees();
    fetchAllSuperDistributor();
  }, []);

  const handleChangeStatus = (data: { id: any; status: string }) => {
    console.error("Status change data:", data);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(sDistributorData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Visit Allow");
    XLSX.writeFile(workbook, "Super Distributors Visit Allow List.xlsx");
  };

  const sDistributorcolumn = [
    {
      title: "Sr No.",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.key.localeCompare(b.key),
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: sdistributorData) => (
        <div>{record.createdAt}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: sdistributorData) => (
        <div className="d-flex align-items-center">
          <div className="avatar avatar-md">
            <img
              src={`assets/img/users/${record.Image}`}
              className="img-fluid rounded-circle"
              alt=""
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">{record.Name}</p>
          </div>
        </div>
      ),
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: sdistributorData) => (
        <span
          // className="dropdown"
          onClick={() => handleChangeStatus({ id: record.id, status: text })}
        >
          <div
            className={`badge  btn btn-white ${
              text === "Active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {text}
          </div>
        </span>
      ),
      sorter: (a: sdistributorData, b: sdistributorData) =>
        a.Status.localeCompare(b.Status),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: EmployeeData, record: sdistributorData) => (
        <div className="action-icon d-inline-flex">
          <Link
            to={`/superdistributor?super_distributor_id=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
          <div data-bs-toggle="modal" data-bs-target="#visits">
            <button
              onClick={() => handleChangeNewStatus({ data: record })}
              className="btn btn-primary"
            >
              Visits
            </button>
          </div>
        </div>
      ),
    },
  ];

  const handleChangeNewStatus = async (data: { data: any }) => {
    const date = new Date();
    setProducts(data.data);
    const formattedDate = date.toISOString().split("T")[0];
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      await uploadFile(formData);
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
  };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const payload = {
      status: "pending",
      employee_id: selectedOption?.value,
      visitor_id: products?.id,
      type: "super-distributor",
      regular_visit: regularVisit,
      one_time_visit: oneTimeaVisit,
    };
    try {
      const response = await createNewVisitor(payload);
      if (response.status === true) {
        setSelectedOption(undefined);
        setProducts("");
        setImage(null);
        setError("");
        setSuccessCreation(true);
      }
    } catch (error) {}
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-body p-0">
              <h3 style={{ margin: "10px" }}>Super-Distributors</h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  margin: "20px 0px 0px 6rem",
                }}
              >
                <div className="dropdown me-3">
                  <Link
                    style={{
                      background: "#3ab54bbf",
                      color: "#fff",
                    }}
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Export
                  </Link>

                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    {/* <li>
                                      <div
                                        onClick={exportToPDF}
                                        className="btn  dropdown-item rounded-1"
                                      >
                                        <i className="ti ti-file-type-pdf me-1" />
                                        Export as PDF
                                      </div>
                                    </li> */}
                    <li>
                      <div
                        onClick={exportToExcel}
                        className=" btn  dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              {sDistributorData && sDistributorData.length > 0 && (
                <Table
                  dataSource={sDistributorData}
                  columns={sDistributorcolumn}
                  Selection={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="basic-info"
                  role="tabpanel"
                  aria-labelledby="info-tab"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Full Name
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="name"
                            value={name}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Description
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="discription"
                            value={discription}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Email
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Address
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            name="address"
                            value={address}
                            onChange={handleChange}
                            className="form-control"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="profile-upload">
                            <div className="mb-2">
                              <h6 className="mb-1">Upload Profile Image</h6>
                              <p className="fs-12">
                                Image should be below 4 MB
                              </p>
                              {error && <p className="text-danger">{error}</p>}
                            </div>
                            <div className="profile-uploader d-flex align-items-center">
                              <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                Upload
                                <input
                                  type="file"
                                  className="form-control image-sign"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                />
                              </div>
                              <Link
                                to="#"
                                className="btn btn-light btn-sm"
                                onClick={handleCancel}
                              >
                                Cancel
                              </Link>
                            </div>
                            {image && (
                              <div className="mt-3">
                                <p>Preview:</p>
                                <img
                                  src={URL.createObjectURL(image)}
                                  alt="Profile Preview"
                                  className="img-thumbnail"
                                  style={{
                                    maxWidth: "150px",
                                    maxHeight: "150px",
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit{" "}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="visits">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add Visitor</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab2" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="info-tab2"
                      data-bs-toggle="tab"
                      data-bs-target="#basic-info2"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Basic Information
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent2">
                <div
                  className="tab-pane fade show active"
                  id="basic-info2"
                  role="tabpanel"
                  aria-labelledby="info-tab2"
                  tabIndex={0}
                >
                  <div className="modal-body pb-0 ">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="mb-3">
                          <label className="form-label">Select Employees</label>
                          <Select
                            classNamePrefix="react-select"
                            className="select"
                            options={allEmployeeData}
                            value={selectedOption}
                            onChange={handleSelect}
                            placeholder="Select Employees"
                          />
                        </div>
                      </div>
                      <div>
                        <div className="form-check form-check-md">
                          <label className="form-label">One Time Visit</label>
                          <input
                            className="form-check-input"
                            onChange={(e) => setOneTimeVisit(e.target.checked)}
                            type="checkbox"
                          />
                        </div>
                      </div>
                      <div>
                        <div className="form-check form-check-md">
                          <label className="form-label">Regular Visit</label>
                          <input
                            className="form-check-input"
                            onChange={(e) => setRegularVisit(e.target.checked)}
                            type="checkbox"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-outline-light border me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      data-bs-dismiss="modal"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default VisitorsList;
